import { Stack, styled } from '@mui/material';

export const BasicTableStyle = styled(Stack)(() => ({
	position: 'relative',
	'& .BasicTable': {
		'& .BasicTable-TableHead': {
			background: 'rgba(199, 229, 222, .2)',
		},
		'& .BasicTable-TableHeadCell': {
			whiteSpace: 'nowrap',
			height: '32px',
			padding: '0 16px',
			'& .BasicTable-tableHeadSortLabel': {
				background: 'none',
				'& .MuiTableSortLabel-icon': {
					display: 'none',
				},
				'& .BasicTable-SortIcon': {
					width: '20px',
					paddingRight: '18px',
					position: 'relative',
					'&:before, &:after': {
						border: '4px solid transparent',
						content: '""',
						display: 'block',
						height: '0',
						right: '5px',
						top: '50%',
						position: 'absolute',
						width: '0',
					},
					'&:before': {
						borderBottomColor: '#666',
						marginTop: '-9px',
					},
					'&:after': {
						borderTopColor: '#666',
						marginTop: '1px',
					},
				},
			},
		},
		'& .collapse': {
			'&.collapse-open': {
				'& .arrow-collapse': {
					transform: 'rotate(-180deg)',
					transition: '0.6s ease',
					svg: {
						poligon: {
							fill: 'red',
						},
					},
				},
			},
			'&.collapse-close': {
				'& .arrow-collapse': {
					transform: 'rotate(0deg)',
					transition: '0.6s ease',
				},
			},
		},
		'& .BasicTable-tableRow': {
			'&.rowAction': {
				cursor: 'pointer',
				'&:hover': {
					background: 'rgba(199, 229, 222, .1)',
				},
			},
			'&.alignTop': {
				'& .BasicTable-tableCell': {
					verticalAlign: 'top',
				},
			},
		},
		'& .BasicTable-tableCell': {
			whiteSpace: 'nowrap',
		},
	},
	'& .BasicTable-TablePaginationPages': {
		direction: 'rtl',
		margin: 'auto',
		display: 'flex',
		'& .MuiPagination-ul': {
			margin: 'auto',
		},
		'& button': {
			background: 'none',
		},
		'& .Mui-selected.MuiPaginationItem-page': {
			background: '#eee',
		},
	},
}));
